import axios from "axios";
import APILinks from "@/links/links";

export default {
  getCountries() {
    const headers = {
      "Content-Type": "application/json",
    };
    return axios.get(APILinks.GENERAL() + "?name=countries", { headers: headers });
  },
};
